import React, { Component } from "react";
import {
  Text,
  View,
  TouchableOpacity,
  Image,
  ImageBackground,
  StyleSheet,
  ScrollView,
  Platform,
  Dimensions,
} from "react-native";
const gStyles = global.gStyles //    "../../../styles/gStyles";

const SCREEN_WIDTH = Dimensions.get("window").width;

// const SLIDE_DATA = [
//   { text: "Welcome >>>" },
//   { text: "This is Wakanda Market" },
//   { text: "Wakanda Market is great!" }
// ];

class Slider extends Component {
  renderSlides() {
    return this.props.data.map(slide => {
      return (
        <View key={slide.text} style={styles.container}>
          <Text style={styles.text}>{slide.text}</Text>
          <Text> </Text>
        </View>
      );
    });
  }
  render() {
    return (
      <View>
        <ScrollView horizontal pagingEnabled style={{ flex: 1 }}>
          {this.renderSlides()}
        </ScrollView>
      </View>
    );
  }
}

class WelcomeScreen extends Component {
  static navigationOptions = {
    //tabBarVisible: false,
  };

  render() {
    return (
      <ImageBackground
        source={require("../images/logos/SC-Background.jpg")}
        style={{
          flex: 1.2,
          opacity: 1,
          alignItems: "center",
          justifyContent: "space-between",
          backgroundColor: "#000"
        }}
      >
        <View style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
          <View
            style={{
              width: SCREEN_WIDTH,
              borderWidth: 0,
              ...Platform.select({
                ios: {
                  height: 0
                },
                android: {
                  height: 150
                }
              })
            }}
          />
          <View
            style={{
              flex: 5,
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            {/* <Text style={{ color: "#fff", fontSize: 24, marginTop: 15 }}>
              Welcome!
            </Text> */}
            <Image
              style={{ width: 162, height: 162 }}
              source={require("../../../custom/Speakers/images/logos/SC-Logo.png")}
            />
            <View style={{ alignSelf: "center", margin: 20 }}>
              <Text style={{ color: "#fff", fontSize: 36,fontWeight:"bold", margin: 4,marginBottom:25, textAlign: "center", fontFamily: Platform.OS === "ios" ? 'DamascusMedium' : 'Roboto' }}>
                Speakers Connect
            </Text>
              <Text style={{ color: "#fff", fontSize: 18, margin: 4, textAlign: "center", fontFamily: Platform.OS === "ios" ? 'DamascusMedium' : 'Roboto' }}>
                Find Professional Public Speakers
            </Text>
              <Text style={{ color: "#fff", fontSize: 13, margin: 4, textAlign: "center", fontFamily: Platform.OS === "ios" ? 'DamascusMedium' : 'Roboto' }}>
                Your needs - Your budget -  Near you - Instant
            </Text>
            </View>
          </View>
          <View style={{ flex: 1, alignItems: "center" }}>


            <Text style={{ color: "#fff", fontSize: 14, margin: 5 }} />
            {/* <Text style={{ color: "#fff", fontSize: 14, margin: 5 }} >PLACE SLIDER HERE!</Text> */}
          </View>
          <View style={{ flex: 1.4, alignItems: "center" }}>
            <TouchableOpacity
              onPress={() => this.props.navigation.navigate("signin")}
              style={[global.gStyles.buttonXLW,{width:150,alignSelf:"center"}]}
            >
              <Text style={{ color: "#fff", fontSize: 16, margin: 5, marginBottom: 5, fontFamily: Platform.OS === "ios" ? 'DamascusMedium' : 'Roboto' }}>
                Continue...
              </Text>
            </TouchableOpacity>
          </View>
        </View>
        <View style={{ flexDirection: "row", position: "absolute", bottom: 25, alignItems: "flex-end", justifyContent: "center", marginTop: 15 }}>
          <Text style={{ fontSize: 14, color: "#fff", fontWeight: "bold" }} >powered by</Text>
          <Image
            style={{ width: 30, height: 24, marginLeft: 5, }}
            source={require("../../../images/logos/home_logo.png")}
          />
          <Text style={{ fontSize: 14, color: "#fff", fontWeight: "bold" }}>WAKANDA</Text>
        </View>
      </ImageBackground>
    );
  }
}

const styles = ({
  container1: {
    flex: 4,
    alignItems: "center",
    justifyContent: "center",
    width: SCREEN_WIDTH,
    backgroundColor: "#000"
  },
  container: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    width: SCREEN_WIDTH,
    backgroundColor: "#000"
  },
  text: {
    fontSize: 30
  }
});

export default WelcomeScreen;
